import Box from "@mui/material/Box";

import { actionLayerUpdate } from "./LayerRedux";
import { useDispatch, useSelector } from "react-redux";

import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";

const radioGroup_ = (theme) => ({
  paddingLeft: "4px",
  "& .MuiRadio-root": {
    padding: "1px",
    marginRight: "4px",
  },
  "& .MuiTypography-overline": {
    lineHeight: 1,
  },
});

const label_ = (theme) => ({
  height: 28,
});

export default function ColorTabPanel({ layers }) {
  const color = useSelector((state) => state.layerReducer.color);
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const data = {
      id: event.target.value,
      faavailable: color.faavailable,
      shared: color.shared,
    };
    dispatch(actionLayerUpdate({ type: "color", data }));
  };

  const handleSwitchChange = (event) => {
    if (event.target.name === "shared") {
      const data = {
        id: color.color,
        faavailable: color.faavailable,
        shared: !color.shared,
      };
      dispatch(actionLayerUpdate({ type: "color", data }));
    } else {
      const data = {
        id: color.color,
        faavailable: !color.faavailable,
        shared: color.shared,
      };
      dispatch(actionLayerUpdate({ type: "color", data }));
    }
  };

  return (
    <Stack>
      <RadioGroup
        aria-label="Color Layer"
        name="layer-color"
        value={color.color}
        onChange={handleChange}
        sx={radioGroup_}
      >
        {layers
          .filter((layer) => layer.type === "color" && layer.radio)
          .map((layer) => (
            <Color layer={layer} key={layer.id} tooltip={layer.tooltip} />
          ))}
      </RadioGroup>
      <FormGroup sx={radioGroup_}>
        {layers
          .filter((layer) => layer.type === "color" && !layer.radio)
          .map((layer) => (
            <ColorSwitch
              layer={layer}
              key={layer.id}
              handleSwitch={handleSwitchChange}
              checked={color[layer.id]}
            />
          ))}
      </FormGroup>
    </Stack>
  );
}

function TooltipWrapper({ tooltips, children }) {
  return tooltips && tooltips.length > 0 ? (
    <Tooltip
      title={tooltips.map((tooltip, i) => (
        <Box key={i}>{tooltip}</Box>
      ))}
      placement="bottom-start"
    >
      {children}
    </Tooltip>
  ) : (
    children
  );
}

function Color({ layer }) {
  const { id, label, tooltips, key } = layer;

  return (
    <TooltipWrapper tooltips={tooltips} key={key}>
      <FormControlLabel
        sx={label_}
        value={id}
        control={<Radio color="primary" />}
        label={
          <Typography
            variant="overline"
            data-testid={`layer-color-label-${id}`}
          >
            {label}
          </Typography>
        }
      />
    </TooltipWrapper>
  );
}

function ColorSwitch({ layer, handleSwitch, checked }) {
  const { id, label, tooltips, key } = layer;

  return (
    <TooltipWrapper tooltips={tooltips} key={key}>
      <FormControlLabel
        sx={label_}
        control={
          <Switch
            color="primary"
            checked={checked}
            onChange={(event) => handleSwitch(event)}
            name={id}
          />
        }
        label={
          <Typography
            variant="overline"
            data-testid={`layer-color-label-${id}`}
          >
            {label}
          </Typography>
        }
      />
    </TooltipWrapper>
  );
}
